import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMouseScrollUp"><Path d="M15 3.99999L13.1094 2.73959C12.4376 2.29172 11.5624 2.29172 10.8906 2.73959L9 3.99999M12 10.75V13.25M12 22.25C9.10051 22.25 6.75 19.8995 6.75 17V12C6.75 9.10049 9.10051 6.74999 12 6.74999C14.8995 6.74999 17.25 9.10049 17.25 12V17C17.25 19.8995 14.8995 22.25 12 22.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMouseScrollUp;
